<div class="vox-table dids-table">
  <table>
    <thead>
      <tr>
        <td translate>
          <div class="label-container">
            <span translate>company.dids.dids-list.table.thead.number.label</span>
          </div>
        </td>
        <td translate>
          <div class="label-container">
            <span translate>company.dids.dids-list.table.thead.type.label</span>
          </div>
        </td>
        <td translate>
          <div class="label-container">
            <span translate>company.dids.dids-list.table.thead.class.label</span>
          </div>
        </td>
        <td translate>
          <div class="label-container">
            <span translate>company.dids.dids-list.table.thead.area-code.label</span>
          </div>
        </td>
        <td translate>
          <div class="label-container">
            <span translate>company.dids.dids-list.table.thead.provider.label</span>
          </div>
        </td>
        <td translate>company.dids.dids-list.table.thead.status.label</td>
        <td translate>company.dids.dids-list.table.thead.creation-date.label</td>
        <td translate>company.dids.dids-list.table.thead.inbound-sms.label</td>
        <td translate>
          company.dids.dids-list.table.thead.whatsapp-calls.label
        </td>
        <td translate>company.dids.dids-list.table.thead.actions.label</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <ng-container *ngFor="let did of dids">
        <tr *ngIf="did._isDeleting">
          <td colspan="9">
            <ngx-skeleton-loader></ngx-skeleton-loader>
          </td>
        </tr>
        <tr *ngIf="!did._isDeleting">
          <td>
            <span [title]="did.country" class="flag-icon flag-icon-{{(did.country || 'unknown') | lowercase}}"></span>
            {{did.number}}
          </td>
          <td>
            <span class="vox-chip vox-chip_royal-blue-text text-uppercase mb-1" translate>
              {{did.did_type}}
            </span>
            <br>
            <span class="vox-chip vox-chip_dark-grey-text text-uppercase" *ngIf="did.is_from_pool"
              translate>company.dids.dids-list.table.temporary</span>
            <span class="vox-chip vox-chip_aquamarine-text text-uppercase" *ngIf="!did.is_from_pool"
              translate>company.dids.dids-list.table.permanent</span>
          </td>
          <td>{{did.did_class}}</td>
          <td>{{did.area_code}}</td>
          <td class="provider">{{did.provider}}</td>
          <td>
            <gdp-did-status [status]="did.status"></gdp-did-status>
          </td>
          <td>{{did.creation_date | date: 'dd/MM/yyyy'}}</td>
          <td>
            <vox-toggle
              [config]="{isAquamarine: true, disabled: company.readOnly || ![DID_STATUS.ACTIVE, DID_STATUS.UNDER_TESTING].includes(did.status)}"
              [toggleOn]="did.is_inbound_sms_enabled"
              [loading]="updatingInboundSms === did.id"
              (toggleOnChange)="toggleInboundSmsConfirmation(did, $event)"
            ></vox-toggle>
          </td>
          <td>
            <vox-toggle
              [config]="{isAquamarine: true, disabled: company.readOnly || ![DID_STATUS.ACTIVE, DID_STATUS.UNDER_TESTING].includes(did.status)}"
              [toggleOn]="did.is_whatsapp_enabled"
              [loading]="updatingWhatsapp === did.id"
              (toggleOnChange)="toggleWhatsappConfirmation(did, $event)"
            ></vox-toggle>
          </td>
          <td>
            <span class="tooltip-container" [ngbTooltip]="getTooltip(did) | translate">
              <button class="vox-btn btn btn-warning"
                [disabled]="did.is_from_pool || [null, undefined].includes(did.verification_data_id) && [null, undefined].includes(did.portability_request_id)"
                (click)="openDocumentsDetails(did)">
                <i class="icon-small-info"></i>
              </button>
            </span>


            <!-- TODO: uncomment below when linking will be working properly -->
            <button class="vox-btn btn btn-warning" *ngIf="did.status === DID_STATUS.WAITING_VERIFICATION_DATA"
              [ngbTooltip]="'company.dids.dids-list.table.tooltip.add-vd' | translate" [ladda]="did._isActivating"
              (click)="onAddVDPopup(did)">
              <i class="icon-small-template"></i>
            </button>
            <button class="vox-btn btn btn-warning" *ngIf="did.status !== DID_STATUS.WAITING_VERIFICATION_DATA"
              [disabled]="company.readOnly || [DID_STATUS.ACTIVE,DID_STATUS.WAITING_VERIFICATION_DATA].includes(did.status)"
              [ladda]="did._isActivating" [ngbTooltip]="'company.dids.dids-list.table.tooltip.activate' | translate"
              (click)="onActivateDid(did)">
              <i class="icon-small-check-circle"></i>
            </button>

            <!-- TODO: uncomment when we need replace with new DID -->
            <!-- <span class="tooltip-container"
                      [ngbTooltip]="(did.is_from_pool ? 'company.dids.dids-list.table.tooltip.replace-tmp' : 'company.dids.dids-list.table.tooltip.replace-new') | translate"
                    >
                      <button class="vox-btn btn btn-warning"
                        [disabled]="company.readOnly || did.is_from_pool"
                        (click)="openReplaceWithNewDidPopup(did)"
                      >
                        <i class="fas fa-sync-alt"></i>
                      </button>
                    </span> -->

            <span class="tooltip-container" [ngbTooltip]="getReplaceTooltipToken(did) | translate">
              <button class="vox-btn btn btn-warning"
                [disabled]="company.readOnly || did.is_from_pool || checkDidDeletionStatus(did)"
                (click)="openReplaceWithExistingDidPopup(did)">
                <i class="icon-small-edit"></i>
              </button>
            </span>

            <span class="tooltip-container" [ngbTooltip]="(company.readOnly || did.is_from_pool || checkDidDeletionStatus(did)) ? ('company.dids.dids-list.table.tooltip.update-provider-tooltip' | translate) : ''">
              <button class="vox-btn btn btn-warning"
                [disabled]="company.readOnly || did.is_from_pool || checkDidDeletionStatus(did)"
                (click)="openUpdateDidProviderPopup(did)">
                <i class="icon icon-small-contacts-internal"></i>
              </button>
            </span>

            <button class="vox-btn btn btn-danger"
              [disabled]="company.readOnly || did.status === DID_STATUS.SCHEDULED_DELETION"
              (click)="deleteDid(did)">
              <i class="icon-small-delete"></i>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of [1,2,3,4]">
        <td colspan="9">
          <ngx-skeleton-loader [theme]="{ 'margin-bottom': 0 }"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && dids.length === 0">
      <tr>
        <td colspan="9" translate style="text-align: center;">company.dids.dids-list.empty</td>
      </tr>
    </tbody>
  </table>
</div>
